import { Modal } from '@/components/common/dialog';
import { useConfigStore } from '@/stores';
import type { CacheScreenSaverInfo } from '@/types';
import { useTranslation } from 'react-i18next';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    screenSaver: CacheScreenSaverInfo[] | [];
};

export const ScreenSaverListPopup = ({ isOpen, onClose, screenSaver }: Props) => {
    const { t, i18n } = useTranslation();
    const language = i18n.language;
    const mainLanguage = useConfigStore((s) => s.config?.ui.mainLanguage);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            className={'max-w-[calc(620*var(--vw-unit))]'}
            title={t('home.title.screen_saver_list')}
            titleAriaLabel={t('home.title.screen_saver_list')}
            closeRegionOrder={2}
            closeTabIndex={0}
        >
            <section className="h-[calc(600*var(--vh-unit))] overflow-hidden p-[calc(20*var(--vw-unit))] pb-[calc(50*var(--vh-unit))]">
                <section
                    className={'scrollbar-custom-gray-99938f scrollbar-w-4 flex h-full flex-col overflow-y-auto'}
                    data-modal-region
                    data-modal-region-order={1}
                    tabIndex={-1}
                >
                    {Array.isArray(screenSaver) &&
                        screenSaver.map((item) => {
                            const title = item?.originalData?.title[language] ?? item?.originalData?.title[mainLanguage];
                            const description =
                                item?.originalData?.description[language] ?? item?.originalData?.description[mainLanguage];

                            return (
                                <div
                                    key={item.id}
                                    className={'flex flex-col gap-[calc(4*var(--vh-unit))] px-[calc(40*var(--vw-unit))] py-[calc(24*var(--vh-unit))]'}
                                >
                                    <div
                                        className={
                                            'focus-border max-w-11/12 text-[calc(24*var(--vh-unit))] leading-[calc(38*var(--vh-unit))] font-bold break-words text-[var(--text-black-02)]'
                                        }
                                        tabIndex={0}
                                        data-interactive
                                        aria-label={title}
                                    >
                                        {title}
                                    </div>
                                    <div
                                        className={
                                            'focus-border text-[calc(16*var(--vh-unit))] leading-[calc(24*var(--vh-unit))] font-medium break-words text-[var(--text-black-02)]'
                                        }
                                        tabIndex={0}
                                        data-interactive
                                        aria-label={description}
                                    >
                                        {description}
                                    </div>
                                </div>
                            );
                        })}
                </section>
            </section>
        </Modal>
    );
};
